module.exports = __webpack_public_path__ + "img/senescent_fibroblasts.2103fa45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/senescent_fibroblasts.jpg
// module id = MIQQ
// module chunks = 0